export const SITE_URL = 'https://elenizafeiri.com';
export const SITE_NAME = 'Eleni Zafeiri';
export const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || '';

export const DEFAULT_DESCRIPTION =
  'Eleni Zafeiri is an Informatics and Telecommunications student at the University of Athens. Founder of TechnotesGR, hackathons, and tech education.';
